import React, { Fragment } from 'react';
import InvoicewiseSalesReportView from './InvoicewiseSalesReportView';

// Thin route entry — the V3 shell lives inside the view.
const InvoicewiseSalesReport = () => (
    <Fragment>
        <InvoicewiseSalesReportView />
    </Fragment>
);

export default InvoicewiseSalesReport;
